// ============================================================
// src/utils/config.js - 完整版
// ============================================================

// 尺寸范围
export const SIZE_RANGE = {
  '女鞋': {
    min: 36,
    max: 43,
    // 档位定义（可选，用于快速批量选择）
    groups: [
      { name: '小', sizes: ['36', '37', '38'] },
      { name: '中', sizes: ['39', '40', '41'] },
      { name: '大', sizes: ['42', '43'] },
    ]
  },
  '童鞋': {
    min: 26,
    max: 36,
    groups: [
      { name: '小', sizes: ['26', '27', '28'] },
      { name: '中', sizes: ['29', '30', '31'] },
      { name: '大', sizes: ['32', '33', '34'] },
      { name: '最大', sizes: ['35', '36'] },
    ]
  }
}

export const unitOptions = [
  { label: '双', value: '双' },
  { label: '米', value: '米' },
  { label: '个', value: '个' },
  { label: '条', value: '条' },
  { label: '块', value: '块' },
  { label: '片', value: '片' },
  { label: '无单位', value: '' },
]

// 基础状态配置
export const BASE_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: '待生产', label: '待生产' },
  { value: '未完成', label: '未完成' },
  { value: '已完成', label: '已完成' },
  { value: '已验收', label: '已验收' },
  { value: '已取消', label: '已取消' }
]

// ============================================================
// 颜色数据
// ============================================================
export const colorData = {
  white: [
    { name: '白色', color: '#ffffff' },
    { name: '米白色', color: '#f5e9c8' },
    { name: '乳白色', color: '#fffaf0' },
    { name: '象牙白', color: '#fffff0' },
  ],
  red: [
    { name: '红色', color: '#ff0000' },
    { name: '桔红色', color: '#ff7500' },
    { name: '玫红色', color: '#df1b76' },
    { name: '粉红色', color: '#ffb6c1' },
    { name: '桃色', color: '#f58f98' },
    { name: '蔷薇色', color: '#f05b72' },
    { name: '深粉红', color: '#ff1493' },
    { name: '胭脂色', color: '#b3424a' },
    { name: '藕色', color: '#eed0d8' },
    { name: '西瓜红', color: '#f05654' },
    { name: '酒红色', color: '#990000' },
    { name: '猩红色', color: '#dc143c' },
    { name: '亮粉色', color: '#ff69b4' },
    { name: '洋红色', color: '#ff00ff' },
    { name: '珊瑚色', color: '#ff7f50' },
    { name: '橙红色', color: '#ff4500' },
    { name: '砖红色', color: '#b22222' },
    { name: '深红色', color: '#8b0000' },
  ],
  black: [{ name: '黑色', color: '#000000' }],
  yellow: [
    { name: '卡其色', color: '#c3b091' },
    { name: '姜黄色', color: '#f7b767' },
    { name: '明黄色', color: '#ffdd00' },
    { name: '杏色', color: '#f8e9d2' },
    { name: '柠檬黄', color: '#fff460' },
    { name: '荧光黄', color: '#e9ff66' },
    { name: '金色', color: '#ffd700' },
    { name: '香槟色', color: '#f8f2cc' },
    { name: '黄色', color: '#ffef00' },
    { name: '浅黄色', color: '#fffbd5' },
    { name: '小麦色', color: '#f5deb3' },
    { name: '橙色', color: '#ff9900' },
    { name: '土黄色', color: '#d8b36e' },
    { name: '向日葵色', color: '#ffb929' },
    { name: '肤色', color: '#f9d5b8' },
  ],
  gray: [
    { name: '深灰色', color: '#666666' },
    { name: '浅灰色', color: '#e0e0e0' },
    { name: '奶奶灰', color: '#d9d9d9' },
    { name: '灰色', color: '#888888' },
    { name: '铅色', color: '#808080' },
    { name: '石板灰', color: '#708090' },
    { name: '银灰色', color: '#c0c0c0' },
    { name: '深空灰', color: '#949494' },
    { name: '石墨色', color: '#555555' },
  ],
  blue: [
    { name: '天蓝色', color: '#87ceeb' },
    { name: '孔雀蓝', color: '#0099aa' },
    { name: '宝蓝色', color: '#4169e1' },
    { name: '浅蓝色', color: '#bfe6f2' },
    { name: '蓝色', color: '#0000ff' },
    { name: '湖蓝色', color: '#48d1cc' },
    { name: '亮钢蓝', color: '#b0c4de' },
    { name: '道奇蓝', color: '#1e90ff' },
    { name: '天蓝色', color: '#add8e6' },
    { name: '深天蓝', color: '#00bfff' },
    { name: '军服蓝', color: '#5f9ea0' },
    { name: '蔚蓝色', color: '#e0f7fa' },
    { name: '淡青色', color: '#e0ffff' },
    { name: '青色', color: '#00ffff' },
    { name: '暗青色', color: '#008b8b' },
    { name: '藏青色', color: '#191970' },
    { name: '粉蓝色', color: '#b0e0e6' },
    { name: '孔雀蓝', color: '#008b9c' },
    { name: '海蓝色', color: '#2f4f4f' },
  ],
  green: [
    { name: '军绿色', color: '#556b2f' },
    { name: '墨绿色', color: '#006400' },
    { name: '浅绿色', color: '#90ee90' },
    { name: '绿色', color: '#008000' },
    { name: '翠绿色', color: '#00c851' },
    { name: '孔雀绿', color: '#cc9933' },
    { name: '荧光绿', color: '#39ff14' },
    { name: '绿黄色', color: '#adff2f' },
    { name: '草绿色', color: '#7cfc00' },
    { name: '黄绿色', color: '#9acd32' },
    { name: '碧绿', color: '#7fffd4' },
    { name: '绿宝石', color: '#40e0d0' },
    { name: '海洋绿', color: '#2e8b57' },
    { name: '橄榄色', color: '#808000' },
    { name: '橄榄绿', color: '#6b8e23' },
    { name: '抹茶色', color: '#b8c18b' },
    { name: '孔雀绿', color: '#008080' },
  ],
  purple: [
    { name: '浅紫色', color: '#e6dce6' },
    { name: '深紫色', color: '#4b0082' },
    { name: '紫红色', color: '#990066' },
    { name: '紫罗兰', color: '#ee82ee' },
    { name: '暗紫罗兰', color: '#9400d3' },
    { name: '紫色', color: '#800080' },
    { name: '深洋红色', color: '#8e008e' },
    { name: '紫兰色', color: '#660099' },
    { name: '薰衣草淡紫', color: '#e6e6fa' },
  ],
  brown: [
    { name: '咖啡色', color: '#603912' },
    { name: '巧克力色', color: '#8b4513' },
    { name: '栗色', color: '#800000' },
    { name: '深卡其布色', color: '#bdb76b' },
    { name: '浅棕色', color: '#a0522d' },
    { name: '深棕色', color: '#5c3317' },
    { name: '褐色', color: '#8b4513' },
    { name: '棕褐色', color: '#cd853f' },
    { name: '驼色', color: '#c19a6b' },
    { name: '橄榄棕色', color: '#6b4423' },
    { name: '红褐色', color: '#7b3f00' },
    { name: '茶色', color: '#d2b48c' },
    { name: '亚麻色', color: '#b8860b' },
    { name: '黄土赭色', color: '#c27e38' },
    { name: '琥珀色', color: '#d37b37' },
    { name: '小豆色', color: '#9e5b51' },
    { name: '焦糖色', color: '#8b5a2b' },
    { name: '肉桂色', color: '#cd7f32' },
    { name: '玫瑰棕色', color: '#b78484' },
    { name: '古铜色', color: '#b87333' },
  ],
}